<template>
  <div>
    <v-card>
      <v-card-title class="pink darken-4">
        <h2 class="display-12 white--text font-weight-light">Customize</h2>
      </v-card-title>
      <v-container>
        <form>
          <v-text-field
            v-model="name"
            label="Name your budget"
            required
            clearable="clear"
            v-slot:append-item
            :rules="rules"
          >></v-text-field>
        </form>
        <v-select
          v-model="frequency.text"
          :items="frequency"
          label="Choose your frequency"
          clearable
        ></v-select>
        <template v-slot:append-item></template>
        <v-select
        v-model="type.text"
        :items="type"
        label="Choose type"
        clearable>
        </v-select>
        <template v-slot:append-item></template>
        <v-select
        v-model="merchantList"
        :items="merchantList"
        label="Choose category"
        clearable>
        </v-select>
      </v-container>
      <template v-slot:append-item></template>
    </v-card>
<v-card>
    <v-card-title class="test">
        <h2 class="display-12 font-weight-light">Choose merchants</h2>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="merchantList"
      :search="search"
      :pagination.sync="pagination"
      select-all
      item-key="name"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.stop="toggleAll"
            ></v-checkbox>
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td>
            <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
          </td>
          <td @click="selectUser(props.item)"/>
          <td>{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.category }}</td>
        </tr>
      </template>
    </v-data-table>
    </v-card>
    <v-card class="preview">
      <h3 class="choices">Budget name: {{ name }}</h3>
      <h3 class="choices">Frequency: {{ frequency.text }}</h3>
      <h3 class="choices">Type: {{ type.text }}</h3>
    </v-card>
    <v-btn v-on:click="submit">post</v-btn>
    <v-btn v-on:click="clear">cancel</v-btn>
  </div>
</template>
<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')
export default {
  props: ['auth'],
  data: () => ({
    frequency: [
      { text: 'Daily', value: 'Daily' },
      { text: 'Weekly', value: 'Weekly' },
      { text: 'Bi-Weekly', value: 'Bi-Weekly' },
      { text: 'Monthly', value: 'Monthly' }
    ],
    type: [
      { text: 'Per merchant', value: 'Per merchant' },
      { text: 'Multiple merchants', value: 'Multiple merchants' },
      { text: 'All merchants', value: 'All merchants' }
    ],
    selectedFreq: [],
    rules: [
      value => !!value || 'Required.',
      value => (value || '').length <= 20 || 'Max 20 characters'
    ],
    loadingUsers: false,
    search: '',
    pagination: {
      sortBy: 'name'
    },
    rowsPerPage: 10,
    selected: [],
    headers: [
      {
        text: 'Merchant',
        align: 'left',
        value: 'name'
      },
      { text: 'Category', value: 'category' }
    ],
    merchantList: []
  }),
  computed: {

  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.loadingUsers = true
      this.userSearchPanelModel = 0
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_MERCHANTS}/merchants`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      this.merchantList = getResponse.data
      this.loadingUsers = false
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.merchants.slice()
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>
<style>
.preview {
  padding: 20px;
  margin-left: 10px;
  margin-right: 10px;
}
.test {
  background-color: #880e4f;
  color: white;
}
.choices {
  font-weight: light;
  color: #880e4f;
  text-align: left;
  margin: 20px auto;
  padding: 20px auto;
}
</style>
